class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.applyButton = this.querySelector(".cart-discount_button");
    this.input = this.querySelector(".cart-discount_input");
    //Connect Listeners
    this.applyButton.addEventListener("click", (event) => this.submitDiscount(event));
    this.querySelector(".cart-discount__remove-discount").addEventListener("click", this.removeDiscount.bind(this));
    this.addEventListener("discount:remove", this.removeDiscount.bind(this));
  }

  async submitDiscount(event) {
    event.preventDefault();
    this.applyButton.disabled = true;
    if (localStorage.getItem("discountCode") != null) {
      this.removeDiscount();
      return;
    }
    const discountCode = this.input.value;
    if (discountCode === "") {
      this.setErrorMode("Veuillez saisir un code");
    } else {
      this.applyCode(discountCode);
    }
  }

  async removeDiscount() {
    const badge = this.querySelector(".cart-discount_badge");
    if (badge.classList.contains("loading")) return;
    this.setButtonLoading();
    badge.classList.add("loading");
    localStorage.removeItem("discountCode");
    
    try {
      await this.applyCode("");
    } catch (error) {
      console.error('Erreur lors de la suppression du code de réduction:', error);
    } finally {
      this.updateCart();
      this.setButtonLoaded();
    }
  }

  async applyCode(discountCode) {
    this.setButtonLoading();
    
    // Créer un AbortController pour gérer l'annulation
    const abortController = new AbortController();
    
    try {
      // Récupérer les codes de réduction existants (adaptés au contexte)
      const existingDiscounts = [];
      
      // Vérifier si le code existe déjà
      if (existingDiscounts.includes(discountCode)) {
        this.setErrorMode("Ce code promo est déjà appliqué");
        return;
      }
  
      // Ajouter le nouveau code à la liste existante
      existingDiscounts.push(discountCode);
      
      // Configuration de la requête comme dans le repo
      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ 
          discount: existingDiscounts.join(','),
        }),
        signal: abortController.signal
      };
  
      // Utiliser l'API REST Shopify comme dans le repo
      const response = await fetch(window.Shopify.routes.root + "cart/update.js", config);
      const data = await response.json();
  
      // Vérifier si le code n'est pas applicable
      const failedDiscount = data.discount_codes?.find(discount => 
        discount.code === discountCode && discount.applicable === false
      );
      
      if (failedDiscount) {
        this.setErrorMode("Ce code promo n'est pas applicable");
        return;
      }
  
      // Stocker les informations du code de réduction
      const appliedDiscount = data.discount_codes?.find(
        d => d.code.toUpperCase() === discountCode.toUpperCase()
      );
      
      if (appliedDiscount) {
        const localStorageValue = {
          code: appliedDiscount.code.trim(),
          totalCart: data.total_price || 0,
        };
        localStorage.setItem("discountCode", JSON.stringify(localStorageValue));
      }
      
      this.updateCart();
      this.setButtonLoaded();
    } catch (error) {
      // Gérer l'annulation de la requête
      if (error.name === 'AbortError') {
        return;
      }
      
      console.error('Erreur lors de l\'application du code de réduction:', error);
      this.setErrorMode("Une erreur est survenue");
    }
  }

  setErrorMode(message = "Veuillez saisir un code valide") {
    // Reset the button state
    this.applyButton.disabled = false;
    this.applyButton.classList.remove("loading");
    this.applyButton.querySelector(".loading-overlay__spinner").classList.add("hidden");
    // Set the input in error mode
    this.input.focus();
    this.input.classList.add("cart-discount_input-error");
    this.input.placeholder = message;
    this.input.value = "";
    setTimeout(() => {
      this.input.classList.remove("cart-discount_input-error");
      this.input.placeholder = this.input.dataset.defaultPlaceholder;
    }, 2000);
  }

  setButtonLoading() {
    this.applyButton.disabled = true;
    this.applyButton.classList.add("loading");
    this.applyButton.querySelector(".loading-overlay__spinner").classList.remove("hidden");
  }

  setButtonLoaded() {
    this.applyButton.disabled = false;
    this.applyButton.classList.remove("loading");
    this.applyButton.querySelector(".loading-overlay__spinner").classList.add("hidden");
  }

  async updateCart() {
    const discount = localStorage.getItem("discountCode") ? JSON.parse(localStorage.getItem("discountCode")).code : null;

    return await fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          discount: discount,
        },
        sections: "cart-drawer",
        sections_url: window.location.pathname,
      }),
    }).then(() => {
      // Cart page
      if (window.location.pathname.includes("/cart")) {
        window.location.reload();
      }

      // Cart Drawer
      fetch(window.Shopify.routes.root + "?sections=cart-drawer")
        .then((res) => res.json())
        .then((data) => {
          const cartDrawer = document.querySelector("cart-drawer");
          cartDrawer.innerHTML = new DOMParser().parseFromString(data["cart-drawer"], "text/html").querySelector("cart-drawer").innerHTML;
          setTimeout(() => {
            cartDrawer.enableOverlayClick();
          });
          if (typeof initUpsellSlider === "function") {
            initUpsellSlider();
          }
        });
    });
  }
}

customElements.define("cart-discount", CartDiscount);